import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { Button, Row, Col } from "react-bootstrap";
import "./categoryForm.css";

function CategoryForm({ show, handleClose, handleSubmit, category }) {
  const [iconPreview, setIconPreview] = useState(category?.icon || "");

  const [formData, setFormData] = useState({
    category_name: category?.category_name || "",
    is_home_listed: category?.is_home_listed || false,
    icon: null,
  });

  useEffect(() => {
    if (category) {
      setFormData({
        category_name: category.category_name,
        is_home_listed: category.is_home_listed,
        icon: null,
      });
      setIconPreview(category.icon || "");
    }
  }, [category]);

  useEffect(() => {
    if (!show) {
      setFormData({
        category_name: "",
        is_home_listed: false,
        icon: null,
      });
      setIconPreview("");
    }
  }, [show]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData({
      ...formData,
      icon: file,
    });

    if (file) {
      setIconPreview(URL.createObjectURL(file));
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    handleSubmit(formData);

    if (!category) {
      setFormData({
        category_name: "",
        is_home_listed: false,
        icon: null,
      });
      setIconPreview("");
    }
  };

  return (
    <Modal
      contentClassName="modal-height"
      size="md"
      className="popup-model"
      show={show}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title style={{ color: "#ff4d4d" }}>
          {category ? "Edit Category" : "Add Category"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="add-category-div">
        <Form onSubmit={handleFormSubmit}>
          <Row className="mb-3">
            <Col xs={12}>
              <Form.Group controlId="formCategoryName">
                <Form.Label>Category Name</Form.Label>
                <Form.Control
                  type="text"
                  name="category_name"
                  value={formData.category_name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col xs={12}>
              <Form.Group controlId="formIcon">
                <Form.Label>Category Icon</Form.Label>
                <Form.Control
                  type="file"
                  name="icon"
                  onChange={handleFileChange}
                />
                {iconPreview && (
                  <div className="image-preview mt-2">
                    <img
                      src={iconPreview}
                      alt="Category Icon"
                      className="img-fluid"
                      style={{ maxHeight: "150px" }}
                    />
                  </div>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6}>
              <Form.Group controlId="formIsHomeListed">
                <Form.Check
                  type="checkbox"
                  label="Is Home Listed"
                  name="is_home_listed"
                  checked={formData.is_home_listed}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Button
            variant="primary"
            type="submit"
            className="w-100 update-add-btn mt-2"
          >
            {category ? "save" : "Add"}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default CategoryForm;
